import React, { useCallback, useEffect, useRef, useState } from "react";
import MainLayout from "../../components/layout/MainLayout";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import Login from "../../app/auth/Login";
import img from "../../app/assets/img/404.jpg";
import Markdown from "react-markdown";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { CircularProgress, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MetadataTable from "../../components/reuseable/MetadataTable";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  ...theme.mixins.toolbar,
}));

const RetailDisplayChecker = () => {
  const [fileName, setFileName] = useState(""); // State to store file name
  const [file, setFile] = useState(null); // Store selected file
  const [uploading, setUploading] = useState(false); // Track upload status
  const [message, setMessage] = useState(""); // Store success/error message
  const [Download, setDownload] = useState(null);
  const [base64img, setbase64img] = useState(null);
  const [data, setData] = useState(null);
  const [complianceAssessment, setComplianceAssessment] = useState(null);
  const [DisplayTypeResult, setDisplayTypeResult] = useState(null);
  const [openUploadModal, setOpenUploadModal] = useState(false);

  const navigate = useNavigate();
  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      setDownload(null);
      setbase64img(null);
      setDisplayTypeResult(null);
      setComplianceAssessment(null);
      setMessage("");
      setFile(acceptedFiles[0]); // Store file
      setFileName(acceptedFiles[0].name); // Set the file name
      setMessage(""); // Clear previous messages
    }
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: { "image/jpeg": [], "image/png": [] }, // Restrict to JPG and PNG files
    multiple: true, // Allow only one file at a time (optional)
  });

  const handleUpload = async () => {
    if (!file) {
      setMessage("Please select a PDF file first.");
      return;
    }

    const formData = new FormData();
    formData.append("image", file); // Key should match the backend API

    try {
      setUploading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_PYTHON_BACKEND_URL}/retailanalyze`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        console.log("response", response);
        const imageData = response.data;
        console.log("imageData", imageData);
        const compliance_assessment = imageData && imageData.compliance_assessment;
        const display_type_result = imageData && imageData.display_type_result;

        console.log("jsonParse", compliance_assessment);

        setComplianceAssessment(compliance_assessment);
        setDisplayTypeResult(display_type_result);
        const input_image_base64 = imageData["input_image_base64"];
        console.log("input_image_base64", input_image_base64);

        setData(imageData);
        setbase64img(input_image_base64);

        // ✅ Close modal AFTER successful upload
        setOpenUploadModal(false);
        setMessage("Upload successful!");
      }
    } catch (error) {
      setMessage("Upload failed. Please try again.");
      console.error("Upload error:", error);
    } finally {
      setUploading(false);
    }
  };
  const timestamp = new Date()
    .toISOString()
    .replace(/[-:T.]/g, "")
    .slice(0, 14); // YYYYMMDDHHMMSS

  const handleDownload = () => {
    if (!base64img) return;

    const link = document.createElement("a");
    link.href = base64img;
    link.download = "downloaded_image.png"; // Set filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // console.log("complianceAssessment",complianceAssessment)

  const KeyValueTable = ({ data }) => {
    console.log(data); // ✅ This will now work

    return (
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ccc", padding: "8px", background: "#333" }}>Key</th>
            <th style={{ border: "1px solid #ccc", padding: "8px", background: "#333" }}>Value</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <tr key={i}>
              <td style={{ border: "1px solid #ccc", padding: "8px" }}>{row.key}</td>
              <td style={{ border: "1px solid #ccc", padding: "8px" }}>{row.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };


  const transformData = (rawObj) => {
    const keys = Object.keys(rawObj);
    return keys.map((value, index) => ({
      key: keys,
      value
    }));
  };



  return (
    <>
      <AuthenticatedTemplate>
        <div
          id="homePage"
          style={{ overflow: "hidden", height: "var(--app-height)" }}
        >
          <Box
            className="mainLayout"
            sx={{ display: "flex", overflow: "hidden" }}
          >
            <MainLayout />

            <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
              <DrawerHeader />

              <div style={{ overflowY: "auto" }} id="mainHome">
                <div
                  style={{
                    height: "100%",
                    alignContent: "baseline",
                    alignItems: "baseline",
                    textAlign: "center",
                    gap: "2rem",
                    display: "grid",
                    // width: "90%",
                    margin: "auto",
                  }}
                >

                  <div className="flex items-start justify-between border-b border-gray-200 pb-4">
                    {/* Left */}
                    <div>
                      <div className="flex items-center gap-2">
                        <div className="bg-[#C800DE] p-[4px] mt-[-9px] inline-flex items-center justify-center cursor-pointer rounded-full">
                          <ArrowBackIcon sx={{ fontSize: "8px", color: "#fff" }} />
                        </div>
                        <h1 className="text-lg font-semibold text-[#656565]">
                          Retail Display Checker
                        </h1>
                      </div>
                      {file && (
                        <p className="text-xs text-gray-500 mt-1 ml-6">
                          Document processed on {new Date().toLocaleDateString('en-US', {
                            month: 'short',
                            day: 'numeric',
                            year: 'numeric'
                          })} at {new Date().toLocaleTimeString('en-US', {
                            hour: 'numeric',
                            minute: '2-digit',
                            hour12: true
                          })}
                        </p>
                      )}
                    </div>

                    {/* Right buttons */}
                    <div className="flex items-center gap-2">
                      <button
                        disabled
                        className="flex items-center gap-2 px-2 py-2 text-sm border rounded-[12px] border-[#818181] text-[#818181] cursor-not-allowed opacity-50"
                      >
                        <VisibilityOutlinedIcon sx={{ fontSize: "14px" }} />
                        Preview
                      </button>

                      <button
                        disabled
                        className="flex items-center gap-2 px-2 text-[12px] py-2 text-sm border border-[#818181] rounded-[12px] text-[#818181] cursor-not-allowed opacity-50"
                      >
                        <ShareOutlinedIcon sx={{ fontSize: "14px" }} />
                        Share
                      </button>

                      <button
                        disabled={base64img === null}
                        onClick={handleDownload}
                        className={`flex items-center gap-2 px-2 py-2 text-sm border rounded-[12px] ${base64img === null
                          ? "border-[#818181] text-[#818181] cursor-not-allowed opacity-50"
                          : "border-[#bb1ccc] text-[#bb1ccc] cursor-pointer hover:bg-[#bb1ccc] hover:text-white"
                          }`}
                      >
                        <FileDownloadOutlinedIcon sx={{ fontSize: "14px" }} />
                        Export
                      </button>

                      <button
                        onClick={() => setOpenUploadModal(true)}
                        className="flex items-center gap-2 px-2 py-2 text-sm font-medium text-white bg-[#bb1ccc] rounded-lg hover:bg-[#a91bb5]"
                      >
                        <UploadFileIcon sx={{ fontSize: "14px" }} />
                        Upload Image
                      </button>
                    </div>
                  </div>

                  {/* Analysis Complete Section */}
                  {base64img && (
                    <div className="mt-6 p-4 border border-gray-200 rounded-lg bg-white">
                      <div className="flex items-start justify-between">
                        <div className="flex items-start gap-3">
                          <div className="mt-1">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="12" cy="12" r="10" fill="#10B981" />
                              <path d="M9 12L11 14L15 10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </div>
                          <div className="text-left">
                            <h3 className="text-base font-semibold text-gray-900">
                              Analysis Complete
                            </h3>
                            <p className="text-sm text-gray-600 mt-1">
                              All compliance checks passed with minor recommendations
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center gap-2 px-3 py-1.5 bg-green-50 border border-green-200 rounded-md">
                          <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                          <span className="text-xs font-medium text-green-700">
                            Processing Complete
                          </span>
                        </div>
                      </div>
                    </div>
                  )}


                  <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                    {base64img && (
                      <>
                        <div style={{ display: "flex", gap: "10px" }}>
                          <img
                            width={400}
                            src={`${base64img}`}
                            alt="Uploaded"
                          />

                          <div>
                            <span style={{ textAlign: "left" }}>
                              <div
                                style={{
                                  fontSize: "18px",
                                  fontWeight: "600",
                                  paddingBottom: "10px",
                                  paddingTop: "10px",
                                }}
                              >
                                Policy Compliance : {data.policy_compliance || 'N/A'}
                              </div>


                            </span>

                            <span style={{ textAlign: "left" }}>
                              <div
                                style={{
                                  fontSize: "18px",
                                  fontWeight: "600",
                                  paddingBottom: "10px",
                                }}
                              >
                                Display Type Result
                              </div>
                              <div
                                style={{
                                  background: "#eee",
                                  padding: "10px",
                                  borderRadius: "10px",
                                  display: "grid",
                                }}
                              >
                                {DisplayTypeResult && (
                                  <>
                                    <span>
                                      <b>Display Type</b> :{" "}
                                      <>
                                        {DisplayTypeResult["Display Type"] ||
                                          "N/A"}
                                      </>{" "}
                                    </span>

                                    <b>Reasoning:</b>
                                    <Markdown>
                                      {DisplayTypeResult.Reasoning}
                                    </Markdown>
                                  </>
                                )}
                              </div>
                            </span>

                            <span style={{ textAlign: "left" }}>
                              <div
                                style={{
                                  fontSize: "18px",
                                  fontWeight: "600",
                                  paddingBottom: "10px",
                                  paddingTop: "10px",
                                }}
                              >
                                Compliance Assessment
                              </div>

                              {complianceAssessment &&
                                complianceAssessment !== null && (
                                  <div
                                    style={{
                                      background: "#eee",
                                      padding: "10px",
                                      borderRadius: "10px",
                                      display: "grid",
                                      fontSize: "16px",

                                    }}
                                  >
                                    <span>
                                      <b>Type</b> :{" "}
                                      <>
                                        {complianceAssessment.Compliance ||
                                          "N/A"}
                                      </>{" "}
                                    </span>
                                    <b>Reasons</b>
                                    <ul>
                                      <li>
                                        <b>Branding visibility </b> :{" "}
                                        {complianceAssessment.Reasons[
                                          "Branding visibility"
                                        ] || "N/A"}
                                      </li>
                                      <li>
                                        <b>Clear signage</b> :{" "}
                                        {complianceAssessment.Reasons[
                                          "Clear signage"
                                        ] || "N/A"}
                                      </li>
                                      <li>
                                        <b>Clutter-free arrangement</b> :{" "}
                                        {complianceAssessment.Reasons[
                                          "Clutter-free arrangement"
                                        ] || "N/A"}
                                      </li>
                                      <li>
                                        <b>Easy customer access</b> :{" "}
                                        {complianceAssessment.Reasons[
                                          "Easy customer access"
                                        ] || "N/A"}
                                      </li>
                                      <li>
                                        <b>Neatness and stacking</b> :{" "}
                                        {complianceAssessment.Reasons[
                                          "Neatness and stacking"
                                        ] || "N/A"}
                                      </li>
                                    </ul>

                                    {/* <Markdown>{data.compliance_assessment}</Markdown> */}
                                  </div>
                                )}
                            </span>

                          </div>
                        </div>

                        <div style={{ width: "100%" }}>
                          <span style={{ textAlign: "left", paddingTop: "10px", display: "block" }}>
                            <div
                              style={{
                                fontSize: "20px",
                                fontWeight: "600",
                                paddingBottom: "10px",
                              }}
                            >
                              Metadata
                            </div>
                            <div
                              style={{
                                background: "#eee",
                                padding: "10px",
                                borderRadius: "10px",
                                display: "grid",
                              }}
                            >
                              <MetadataTable metadata={data.metadata || []} />

                            </div>
                          </span>


                        </div>

                      </>
                    )}
                  </div>
                </div>
              </div>
            </Box>
          </Box>
        </div>
        {/* Upload Modal */}
        <Dialog
          open={openUploadModal}
          onClose={() => {
            setOpenUploadModal(false);
            setFile(null);
            setFileName("");
            setMessage("");
          }}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              mt: 10,
              ml: 20,
            },
          }}
        >
          <DialogContent>
            <div className="p-4">
              <h2 className="text-lg font-semibold text-[#1a1a1a]">
                Upload Image File
              </h2>

              <div
                {...getRootProps()}
                className="mt-6 flex flex-col items-center justify-center
                   border-2 border-dashed border-gray-300 rounded-xl
                   h-[140px] cursor-pointer text-gray-500"
              >
                <input {...getInputProps()} />
                <span>
                  {file ? "File selected" : "Drop or Upload your Image here"}
                </span>
              </div>

              {file && (
                <p className="mt-2 text-sm text-[#bb1ccc]">
                  File Name: <span className="font-medium">{fileName}</span>
                </p>
              )}

              {message && (
                <p className="mt-2 text-sm text-green-600">
                  {message}
                </p>
              )}
            </div>
          </DialogContent>

          <DialogActions className="px-6 pb-4">
            <button
              onClick={() => {
                setOpenUploadModal(false);
                setFile(null);
                setFileName("");
                setMessage("");
              }}
              className="px-6 py-2 border border-gray-300 rounded-lg text-sm"
              disabled={uploading}
            >
              Cancel
            </button>

            <button
              onClick={handleUpload}
              disabled={uploading || !file}
              className="px-6 py-2 bg-[#bb1ccc] text-white rounded-lg text-sm disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {uploading ? (
                <>
                  <CircularProgress size={20} sx={{ color: "white" }} />
                  <span>Processing...</span>
                </>
              ) : (
                "Check"
              )}
            </button>
          </DialogActions>
        </Dialog>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
};

export default RetailDisplayChecker;
